import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { stopPropagation } from 'shared/utils/event/stopPropagation';

import styles from './ControlWrapper.css';

type ControlWrapperProps = {
  visible?: boolean;
  children: JSX.Element | ReactNode[];
};

export const ControlWrapper: FC<ControlWrapperProps> = props => {
  const { children, visible } = props;

  return (
    <div className={clsx(styles['container'], visible && styles['visible'])} onClick={stopPropagation}>
      {children}
    </div>
  );
};
